import { DetailedHTMLProps, InputHTMLAttributes } from "react";
import { FieldErrors, useFormContext } from "react-hook-form";
import { FormInputBaseProps } from "./FormTypes";
import { InputContainer } from "./InputContainer";
import { ControlledInputClassNames } from "./utils";

interface Props
  extends FormInputBaseProps,
    DetailedHTMLProps<
      InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    > {}

export const Input = ({ name, label, className, ...rest }: Props) => {
  const {
    formState: { touchedFields, errors },
    register,
  } = useFormContext();

  return (
    <InputContainer label={label} name={name} className={className}>
      <input
        id={name}
        className={ControlledInputClassNames(
          !!errors[name],
          touchedFields[name]
        )}
        {...register(name, {
          valueAsNumber: rest.type === "number",
          valueAsDate: rest.type === "date",
        })}
        {...rest}
      />
    </InputContainer>
  );
};
